export default "__VITE_ASSET__Dpdzd6RC__"